import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductVarientService {

  constructor(private ws: PostmethodService) { }

  productVariantCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "productVariantMaster");
  }

  getCategory(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "productCategoryMaster");
  }

  getModel(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "productModelMaster");
  }

  getColor(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "productColorMaster");
  }

}
